import { useCallback } from 'react';
import { mutationDeleteTeam } from '@/features/teams/api/mutationDeleteTeam';
import { useAllTeamsList } from '@/features/teams/hooks/useAllTeamsList';
import { useAllTeamsSubscription } from '@/features/teams/hooks/useAllTeamsSubscription';
import { Team } from '@/services/API';
import { PageLoading } from '@/ui/PageLoading';
import AdminTeamListView from './AdminTeamListView';

export default function AdminTeamListClient() {
  const teamList = useAllTeamsList();
  useAllTeamsSubscription();

  const handleDeleteTeam = useCallback((elem: Team) => {
    mutationDeleteTeam(elem.id);
  }, []);

  if (!teamList.data) {
    return <PageLoading />;
  }
  return <AdminTeamListView data={teamList.data} handleDeleteTeam={handleDeleteTeam} />;
}
